// extracted by mini-css-extract-plugin
module.exports = {"instruction_desc":"Instructions_instruction_desc__3_zyi"};